import { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { Badge, Button, ToggleButton, ButtonGroup } from "react-bootstrap";
import { Form } from '../../types';
import { formatDate } from "../../helpers";
const API_URL = process.env.REACT_APP_API_URL;
const currentDate = new Date();

type StudentMainProps = {
  forms: Form[];
  setForms: React.Dispatch<React.SetStateAction<Form[]>>;
  refreshForms: () => Promise<void>;
};

const StudentMain: React.FC<StudentMainProps> = ({ forms, setForms, refreshForms }) => {
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [timezone, setTimezone] = useState("PST");  
  const timezones = ["Local", "PST", "EST", "UTC"];
  // Fetch forms from the backend
  useEffect(() => {
    const fetchForms = async () => {
      try {
        const response = await fetch(`${API_URL}/api/forms`, {
          method: 'GET',
          credentials: 'include',
        });
        const data = await response.json();
        setForms(data);
      } catch (err) {
        console.error('Error fetching forms:', err);
      }
    };
    fetchForms();
  }, [setForms]);

  const FormStatusBadge = ({ form }: { form: Form }) => {
    const formEndDate = form.endDate ? new Date(form.endDate) : null;
    const isFormExpired = formEndDate && formEndDate < currentDate;

    // Determine if the form is open or closed
    const isOpen = form.endOption === 'noDate' || !isFormExpired;

    const status = isOpen ? 'Open' : 'Closed';

    return (
      <Badge
        bg={status === 'Open' ? 'success' : 'danger'}
        className="badge pill-badge fs-6 px-4 py-2"
      >
        {status}
      </Badge>
    );
  };

    const handleRefresh = async () => {
    if (!isRefreshing) {
      setIsRefreshing(true);
      await refreshForms(); // Your function to refresh forms
      setTimeout(() => setIsRefreshing(false), 500); // Remove animation after 0.5s
    }
  };


  //adjust wording on submission button based on submission status. Not currently using this feature
  const SubmissionButton = ({ form }: { form: Form;}) => {
  const navigate = useNavigate();

  const buttonText = form.isComplete ? 'Make Submission' : 'Make Submission'; // changed both to make submission since not currently implementing isComplete feature

  return (
    <button
      className="btn btn-outline-primary"
      onClick={() => navigate(`/form/${form.id}/submissions`)}
      title="Make a form submission"
    >
      {buttonText}
    </button>
    );
  };

    //grabs user role from session storage
  //const userRole = sessionStorage.getItem('role');

  return (
    <div>
      <h3>Sign-Up Tool</h3>
      <p>Select a form below to edit or view submissions.</p>
        <div className="d-flex justify-content-end align-items-end">
          <Button
            size = "sm"   
            variant="outline-primary" 
            onClick={handleRefresh}
            className="click-effect">
            <span className={isRefreshing ? "refresh-icon" : ""}><i className="bi bi-arrow-repeat"></i></span> Refresh Forms
          </Button>
      </div>
      <br />
      <table className="table table-bordered table-striped">
        <thead>
          <tr>
            <th>Title</th>
            <th>Options</th>
            <th>Status</th>
            <th>
              <div className="d-flex justify-content-between align-items-center gap-2">
                <span>Sign-Up End Date</span>
                <ButtonGroup size="sm">
                  {timezones.map((tz) => (
                    <ToggleButton
                      key={tz}
                      id={`tz-${tz}`} // Unique ID
                      type="radio"
                      name="timezone"
                      variant={timezone === tz ? "primary" : "outline-primary"}
                      value={tz} // Required for ToggleButton
                      checked={timezone === tz}
                      onChange={() => setTimezone(tz)}
                    >
                      {tz}
                    </ToggleButton>
                  ))}
                </ButtonGroup>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          {forms.length > 0 ? forms.map((form) => (
            <tr key={form.id}>
              <td>{form.title}</td>
              <td>
                <SubmissionButton form={form} />
              </td>
              <td><FormStatusBadge form={form} /></td>
              <td>{form.endDate ? formatDate(form.endDate, timezone) : "No end date"}</td>
            </tr>
          )) : (
            <tr>
              <td colSpan={4} style={{ textAlign: 'center' }}>No forms yet.</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
export {};
export default StudentMain;
